/*global document, window, yall, setTimeout, Swiper, createElementWithClass, Cookies, semanticTabs, Image, Shopify, Event, getComputedStyle, CustomEvent, IntersectionObserver, MutationObserver, ResizeObserver */
/*//jshint esversion: 6 */
let html_tag = document.documentElement;
let root_styles = document.documentElement;
let top_id = document.querySelector('.shopify-section-header');
let header_outer = document.querySelector('#header-outer');
let header_id = header_outer ? header_outer.querySelector('#header') : null;
let header_inner = document.querySelector('#header-inner');
let logo_id = document.querySelector('#logo');
let search_id = document.querySelector('#search');
let nav_outer = document.querySelector('#nav-outer');
let nav_bar_id = document.querySelector('#nav-bar');
let content_id = document.getElementById('content');
let nav_main = nav_bar_id;

let global_dir;
if (html_tag.getAttribute('dir') === 'rtl') {
	global_dir = ['rtl', false];
} else {
	global_dir = ['ltr', true];
}

function isTouchDevice() {
	'use strict';
	return window.matchMedia("(pointer: coarse)").matches;
}

function onMediaChange(query, match, unmatch) {
	const mediaQuery = window.matchMedia(query);
	const update = function (event) {
		if (event.matches) {
			if (match) match();
		} else if (unmatch) {
			unmatch();
		}
	};
	update(mediaQuery);
	if (typeof mediaQuery.addEventListener === 'function') {
		mediaQuery.addEventListener('change', update);
		return function () { mediaQuery.removeEventListener('change', update); };
	}
	mediaQuery.addListener(update);
	return function () { mediaQuery.removeListener(update); };
}

const isMobile = isTouchDevice();

var listCollectionSliderEvt = new CustomEvent("listCollectionSlider"),
	listCollectionEvt = new CustomEvent("listCollection"),
	semanticSelectEvt = new CustomEvent("semanticSelect"),
	productcardVariantsEvt = new CustomEvent("productcardVariants"),
	quickShopEvt = new CustomEvent('quickShop'),
	ajaxCartEvt = new CustomEvent('ajaxCart'),
	moduleFeaturedSliderEvt = new CustomEvent("moduleFeaturedSlider"),
	listProductSliderEvt = new CustomEvent("listProductSlider"),
	listUspSliderEvt = new CustomEvent("listUspSlider"),
	listTestimonialsSliderEvt = new CustomEvent("listTestimonialsSlider"),
	listStaticSliderEvt = new CustomEvent("listStaticSlider"),
	searchClassesEvt = new CustomEvent("searchClasses"),
	createColsEvt = new CustomEvent("createCols"),
	moduleTabsEvt = new CustomEvent("moduleTabs"),
	formZindexEvt = new CustomEvent("formZindex"),
	inputPaddingEvt = new CustomEvent("inputPadding"),
	backgroundEvt = new CustomEvent("background"),
	lazyVideoEvt = new CustomEvent("lazyVideo"),
	mediaFlexibleEvt = new CustomEvent("mediaFlexbile"),
	sykSliderEvt = new CustomEvent("sykSlider");

let ok_to_resize = true;
window.addEventListener('resize', function () {
	if (ok_to_resize){
		ok_to_resize = false;
		setTimeout(function(){
			ok_to_resize = true;
			window.dispatchEvent(new CustomEvent("windowResize"));
		}, 500);
	}
});

function isHasSelectorSupported() {
	const testElement = document.createElement('div');
	try {
		testElement.querySelector(':has(*)');
		return true;
	} catch (error) {
		return false;
	}
}
function getSiblings(el) {
	'use strict';
	return Array.from(el.parentNode.children).filter(child => child !== el);
}


function append_url(el, content, className, href, access) {
	'use strict';
	const link = createElementWithClass('a', className);
  link.href = href || './';
	if (access === true) {
		link.setAttribute('tabindex', -1);
		link.setAttribute('aria-hidden', true);
		link.setAttribute('focusable', false);
	}
	link.innerHTML += content;
	if (el) {
		el.appendChild(link);
	}
}

function wrap(el, wrapper, className) {
	'use strict';
	el.parentNode.insertBefore(wrapper, el);
	if (className) {
		wrapper.classList.add(className);
	}
	wrapper.appendChild(el);
}

function new_css(id, href, media) {
	"use strict";
	if (!document.getElementById(id)) {
		const a = document.createElement('link');
		if (media === undefined) {
			media = 'screen';
		}
		a.setAttribute('id', id);
		a.setAttribute('rel', 'stylesheet');
		a.setAttribute('href', href);
		a.setAttribute('media', media);

			const b = document.querySelectorAll('link[id]');
			if (b.length) {
				b[b.length - 1].after(a);
			} else {
				document.head.appendChild(a);
		}
	}
}

function create_slider(el, settings, minSlides) {
	'use strict';
	var sliderElement = el,
		bg = false,
		child;

	const imgOverlays = [];
	const fragment = document.createDocumentFragment();
	const serverControls = sliderElement.querySelector(':scope > [data-product-gallery-controls]');
	if (serverControls) serverControls.remove();

	if (el.getElementsByClassName('img-overlay').length) {
		Array.from(el.children).forEach(function (child) {
			if (child.classList.contains('img-overlay')) {
				bg = true;
				imgOverlays.push(child);
				fragment.appendChild(child);
				child.remove();
			}
		});
	}

	if (el.children.length > 1) {
		if (el.tagName.toLowerCase() === "ul") {
			el.setAttribute('role', 'none');
			Array.from(el.children).forEach(child => {
				child.setAttribute('role', 'none');
				child.classList.add('li');
			});
		}

		const items = Array.from(sliderElement.children);
		const wrapperFragment = document.createDocumentFragment();

		if (!minSlides) {
			minSlides = 1;
		}
		if (items.length > parseFloat(minSlides)) {
			var paginationClass;
			paginationClass = (settings && settings.pagination && settings.pagination.el) || ".swiper-pagination";
			paginationClass = paginationClass.replace(/\./g, " ").trim();

			const dots = serverControls ? null : createElementWithClass('span', paginationClass);
			const prev = serverControls?.querySelector('.swiper-button-prev') || createElementWithClass('span', 'swiper-button-prev');
			const next = serverControls?.querySelector('.swiper-button-next') || createElementWithClass('span', 'swiper-button-next');
			sliderElement.classList.add('s4wi');

			prev.classList.add('swiper-button-nav');
			next.classList.add('swiper-button-nav');
			if (prev.tagName.toLowerCase() !== 'button') {
				prev.setAttribute('role', 'button');
				prev.setAttribute('tabindex', '0');
			}
			if (next.tagName.toLowerCase() !== 'button') {
				next.setAttribute('role', 'button');
				next.setAttribute('tabindex', '0');
			}

			items.forEach(el => {
				const slideWrapper = document.createElement('div');
				slideWrapper.classList.add('swiper-slide');
				wrap(el, slideWrapper);
				wrapperFragment.appendChild(slideWrapper);
			});

			const swiperOuter = document.createElement('div');
			swiperOuter.classList.add('swiper-outer');
			const swiperWrapper = document.createElement('div');
			swiperWrapper.classList.add('swiper-wrapper');
			swiperWrapper.appendChild(wrapperFragment);
			swiperOuter.appendChild(swiperWrapper);
			const paginationContainer = serverControls || createElementWithClass('div', 'swiper-custom-pagination');

			sliderElement.innerHTML = '';
			if (serverControls) swiperOuter.append(prev, next);
			sliderElement.appendChild(swiperOuter);
			sliderElement.appendChild(paginationContainer);

			if (!serverControls && settings && settings.pagination) {
				settings.pagination.el = settings.pagination.el || "." + paginationClass;
				paginationContainer.append(prev, dots, createElementWithClass('span', 'swiper-custom-fraction'), next);
			} else if (!serverControls) {
				paginationContainer.append(prev, next);
			}

			const swiperInstance = new Swiper(sliderElement.children[0], settings);

			const paginationBullets = sliderElement.querySelectorAll('.swiper-pagination-bullet');
			paginationBullets.forEach(bullet => {
				if (bullet.tagName.toLowerCase() !== 'button') bullet.setAttribute('role', 'button');
			});

			return swiperInstance;
		}
	}

	if (bg) {
		el.appendChild(fragment);
	}

	return null;
}

function randomize(el) {
	'use strict';
	el.setAttribute('data-random', Math.floor(Math.random() * 10000) + 1);
}

function clone_with_class(el, cl1, cl2) {
	'use strict';
  const cln = el.cloneNode(true);
	cln.classList.add(cl1);
	el.after(cln);
	el.classList.add(cl2);
}

function new_js(el) {
	'use strict';
	if (!el) return;
	const absoluteSrc = new URL(el, document.baseURI).href;
	const alreadyLoaded = Array.from(document.scripts).some(script => script.src === absoluteSrc);
	if (alreadyLoaded) return;
	const tag = document.createElement('script');
	tag.src = el;
	tag.defer = true;
	document.body.appendChild(tag);
}

function assignIndex(elements) {
	const styles = [];
	elements.forEach((el, index) => {
		styles.push({ el, index });
	});
	requestAnimationFrame(() => {
		styles.forEach(({ el, index }) => {
			el.style.zIndex = elements.length - index;
		});
	});
}

var breadcrumb_back = document.querySelectorAll('.breadcrumb-back');
if (breadcrumb_back.length) {
	Array.from(breadcrumb_back).forEach(function (el) {
		if (document.referrer.indexOf(window.location.host) !== -1) {
			el.addEventListener('click', function (e) {
				history.go(-1); return false;
			})
		}
		else { el.remove(); }
	})
}

var select_tag = document.getElementsByTagName('select');
window.addEventListener("formZindex", function (evt) {
	// Assign z-indexes to form elements
	// :placeholder-like support for <select> element
	Array.from(select_tag).forEach(el => {
		const parentNode = el.parentNode;
		const closestParagraph = el.closest('p');

		parentNode.classList.add('has-select');
		if (closestParagraph) {
			closestParagraph.classList.add('has-select');
		}

		el.addEventListener('change', () => {
			el.classList.add('changed');
		});
	});

	let handleFormChildrenCalculated = false;
	function handleFormChildren() {
		if(!handleFormChildrenCalculated){
			var formChildren = document.querySelectorAll('form > *, fieldset > *, .no-zindex, .no-zindex > *, .has-select, .f8pr > *, .l4ca.compact.in-panel > *, .l4cl.box > li');
			if (formChildren.length) {
				assignIndex(formChildren);
			}
			handleFormChildrenCalculated = true;
		}
	}
	if (!isMobile) {
		document.addEventListener('mouseover', handleFormChildren);
	}
	document.addEventListener('keyup', handleFormChildren);
	document.addEventListener('touchstart', handleFormChildren);
	document.addEventListener('scroll', handleFormChildren);
	window.addEventListener('windowResize', handleFormChildren);
});
// window.dispatchEvent(formZindexEvt);

window.addEventListener("inputPadding", function (evt) {
	setTimeout(function () {
		function applyPadding(elements, property) {
			Array.from(elements).forEach(function (el) {
				var c = el.nextElementSibling;
				c.style[property] = el.offsetWidth + 'px';
			});
		}

		// Padding for ".input-prefix" element
		applyPadding(document.querySelectorAll('.input-prefix > span:first-child'), global_dir[1] === false ? 'paddingRight' : 'paddingLeft');

		// Padding for ".input-suffix" element
		applyPadding(document.querySelectorAll('.input-suffix > span:first-child'), global_dir[1] === false ? 'paddingLeft' : 'paddingRight');
	}, 500);
});
setTimeout(function () {
	window.dispatchEvent(inputPaddingEvt);
}, 500);

window.check_limit_event = function() {
	var check_limit = document.querySelectorAll('.check[data-limit]');
	if (check_limit.length) {
		Array.from(check_limit).forEach(function (el) {
			if (!el.classList.contains('check-limit-initialized')) {
				el.classList.add('check-limit-initialized');
				var tag_limit = 'a',
					limitEl,
					limit = parseInt(el.dataset.limit),
					trigger,
					nextAll = false,
					lastDesc;
				if (el.tagName.toLowerCase() === 'ul' || el.tagName.toLowerCase() === 'ol') {
					tag_limit = 'li';
				}
				if (el.children.length >= (limit + 1)) {
					limit = limit - 1
				}
				limitEl = createElementWithClass(tag_limit, 'limit');
				trigger = el.children[limit - 1];

				if (trigger !== undefined) {
					nextAll = [].filter.call(trigger.parentNode.children, function (htmlElement) {
						return (htmlElement.previousElementSibling === trigger) ? nextAll = true : nextAll;
					});
					nextAll.forEach(function (em) {
						if (!em.classList.contains('hidden')) {
							em.classList.add('hidden-check');
						}
					});
					limitEl.innerText = '+' + Math.abs(el.querySelectorAll('li:not(.hidden, .tip-cont)').length - limit);
					if (tag_limit === 'li') {
						limitEl.innerHTML = '<a href="./">' + limitEl.innerHTML + '</a>';
					}
					el.append(limitEl);
					lastDesc = el.querySelector('li.hidden');
					if (lastDesc) {
						el.appendChild(lastDesc);
					}
					Array.from(el.querySelectorAll('a.limit, .limit a')).forEach(function (em) {
						em.addEventListener('click', function (e) {
							el.classList.add('limit-clicked');
							e.preventDefault();
						});
					});
				}
			}
		});
	}
};
check_limit_event();

// Change the position of background element (just for security)
window.addEventListener("background", function(evt) {
	// Change the position of background element (just for security)
	if (document.querySelector('#background.done')) {
		document.querySelector('#background.done').remove();
	}
	const background_id = document.getElementById('background');
	if (background_id && !background_id.classList.contains('static') && (background_id.parentNode.id === 'content' || background_id.parentNode.classList.contains('shopify-section'))) {
		document.getElementById('root').appendChild(background_id);
		background_id.classList.add('done');
	}
});
window.dispatchEvent(backgroundEvt);

// Create tabs
window.addEventListener("moduleTabs", function(evt) {
	var tabs_holder = document.querySelectorAll('#content, .m6pn');
	if (tabs_holder.length) {
		Array.from(tabs_holder).forEach(function (el) {
			const module_tabs = el.getElementsByClassName('m6tb');
			if (module_tabs.length) {
				Array.from(module_tabs).forEach(function (el) {
					if (typeof semanticTabs === 'function' && !el.classList.contains('tabs-initialized')) {
						semanticTabs(el);
					}
					el.classList.add('tabs-initialized');

					let readmore = document.querySelector('.f8pr a[href="#section-info"]');
					if(readmore){
						function onClickReadMore(e){
							let sectionInfoTab = el.querySelector('li.block-description');
							if(sectionInfoTab == null) { return; }
							if(! sectionInfoTab.classList.contains('item-active')) {
								sectionInfoTab.querySelector('a').click();
							}
						}
						readmore.addEventListener('click', onClickReadMore);
					}
				});
			}
		});
	}
});
window.dispatchEvent(moduleTabsEvt);

var list_testimonials, list_static, popup_a;
window.addEventListener("moduleFeaturedSlider", function(event) {
	const module_featured = document.querySelectorAll('.m6fr:not(.s4wi, .flexible-section)');
	if (module_featured.length) {
		Array.from(module_featured).forEach(function (el) {
			var pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				featuredSlider;
			el.querySelectorAll('figure').forEach(function (em) {
				if (em.getElementsByTagName('picture').length > 1) {
					em.classList.add('has-pics');
				}
			});
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true
				};
			}
			randomize(el);
			const randomId = el.getAttribute('data-random');
			featuredSlider = create_slider(el, {
				direction: 'horizontal',
				loop: false,
				autoHeight: true,
				resizeObserver: true,
				autoplay: autoplay_int,
				threshold: 50,
				pagination: {
					el: '.swiper-pagination-' + randomId,
					clickable: true,
					type: pagination_type,
					renderBullet: function (index, className) {
						return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
					},
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				navigation: {
					nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
					prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
				},
				on: {
					afterInit: function (swiper) {
						updateSwiper(swiper);
					},
					slideChangeTransitionStart: function (swiper) {
						updateSwiper(swiper);
					},
					resize: function (swiper) {
						if (typeof Shopify !== 'undefined' && Shopify.designMode) {
							Array.from(featuredSlider.slides).forEach(function () {
								featuredSlider.slideNext(0);
							});
						}
						setTimeout(function () {
							featuredSlider.updateAutoHeight();
						}, 500);

					}
				}

			});
			function updateSwiper(swiper) {
				Array.from(el.querySelectorAll('.swiper-slide > article.aside')).forEach(em => {
					em.parentNode.classList.add('has-aside');
				});
				const active_content = swiper.el.querySelector('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > article');
				if (typeof active_content !== 'undefined' && active_content) {
					el.setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
				}
				if (swiper.realIndex > 0) {
					el.classList.add('changed');
				} else {
					el.classList.remove('changed');
				}
				if (swiper.realIndex + 1 === total_sl) {
					el.classList.add('last-slide-active');
				} else {
					el.classList.remove('last-slide-active');
				}
			}
			if (featuredSlider !== null) {
				if (el.getAttribute('data-autoplay') && !el.classList.contains('no-controls')) {
					append_url(el, 'Play/Pause', 'play-pause');
					el.querySelector('.play-pause').addEventListener('click', function (e) {
						if (el.classList.contains('paused')) {
							el.classList.remove('paused');
							featuredSlider.autoplay.start();
						} else {
							el.classList.add('paused');
							featuredSlider.autoplay.stop();
						}
						e.preventDefault();
					});
					el.addEventListener('mouseleave', function () {
						if (!el.classList.contains('paused')) {
							featuredSlider.autoplay.start();
						}
					});
				}
				window.addEventListener('windowResize', function (event) {
					html_tag.classList.add('resized');
				}, true);
				setTimeout(function () {
					featuredSlider.updateAutoHeight();
				}, 500);
			}
			if (el.classList.contains('s4wi')) {
				setTimeout(function () {
					if (typeof updateSlidersEvt != 'undefined') {
						window.dispatchEvent(updateSlidersEvt);
					}
				}, 300);
			}
		});
	}
});
window.dispatchEvent(moduleFeaturedSliderEvt);

window.addEventListener("listTestimonialsSlider", function(event) {
	list_testimonials = document.querySelectorAll('.l4ts:not(.s4wi)');
	if (list_testimonials.length) {
		Array.from(list_testimonials).forEach(function (el) {
			var ln = [1, 2, 3],
				pagination_type = 'bullets',
				autoplay_int = false,
				total_sl = el.children.length,
				options;
			if (el.classList.contains('wide') || el.classList.contains('w100')) {
				ln = [1, 1, 1];
			}
			if (el.classList.contains('w50')) {
				ln = [1, 2, 2];
			}
			if (el.classList.contains('slider-fraction')) {
				pagination_type = 'fraction';
			}
			if (el.getAttribute('data-autoplay')) {
				autoplay_int = {
					delay: parseFloat(el.getAttribute('data-autoplay')),
					pauseOnMouseEnter: true,
					disableOnInteraction: false
				};
			}
			randomize(el);
			options = {
				direction: 'horizontal',
				loop: true,
				autoHeight: true,
				spaceBetween: 16,
				slidesPerView: ln,
				slidesPerGroup: ln,
				autoplay: autoplay_int,
				pagination: {
					el: '.swiper-pagination-' + el.getAttribute('data-random'),
					clickable: true,
					type: pagination_type,
					renderFraction: function (currentClass, totalClass) {
						return '<span class="' + currentClass + '"></span>' +
							' <span class="slash">/</span> ' +
							'<span class="' + totalClass + '"></span>';
					}
				},
				navigation: {
					nextEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-next',
					prevEl: '[data-random="' + el.getAttribute('data-random') + '"] .swiper-button-prev'
				},
				on: {
					slideChangeTransitionStart: function (swiper) {
						swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
						swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
					}
				},
				breakpoints: {
					0: {
						slidesPerView: ln[0],
						slidesPerGroup: ln[0]
					},
					760: {
						slidesPerView: ln[1],
						slidesPerGroup: ln[1]
					},
					1000: {
						slidesPerView: ln[2],
						slidesPerGroup: ln[2]
					}
				}
			};
			if (el.classList.contains('slider') && el.children.length > ln[2]) {
				create_slider(el, options);
			}
			if (el.classList.contains('slider-mobile') && el.children.length > ln[0]) {
				const nextSibling = el.nextElementSibling;
				clone_with_class(el, 'mobile-only', 'mobile-hide');
				if (nextSibling && nextSibling.classList.contains('mobile-only')) {
					if (nextSibling.hasAttribute('id')) {
						nextSibling.removeAttribute('id');
					}
					create_slider(el.nextElementSibling, options);
				}
			}
		});
	}
});
window.dispatchEvent(listTestimonialsSliderEvt);

window.addEventListener("listStaticSlider", function(event) {
	list_static = document.querySelectorAll('.l4st:not(.s4wi)');
	if (list_static.length) {
		Array.from(list_static).forEach(function (el) {
			if (!el.classList.contains('static')) {
				var pagination_type = 'bullets',
					autoplay_int = false,
					total_sl = el.children.length;
				if (el.classList.contains('slider-fraction')) {
					pagination_type = 'fraction';
				}
				if (el.getAttribute('data-autoplay')) {
					autoplay_int = {
						delay: parseFloat(el.getAttribute('data-autoplay')),
						pauseOnMouseEnter: true,
						disableOnInteraction: false
					};
				}
				randomize(el);
				const randomId = el.getAttribute('data-random');
				clone_with_class(el, 'mobile-only', 'mobile-hide');
				if (el.nextElementSibling.classList.contains('mobile-only')) {
					if (el.nextElementSibling.hasAttribute('id')) {
						el.nextElementSibling.removeAttribute('id');
					}
					create_slider(el.nextElementSibling, {
						direction: 'horizontal',
						loop: false,
						autoHeight: true,
						spaceBetween: 16,
						autoplay: autoplay_int,
						pagination: {
							el: '.swiper-pagination-' + randomId,
							clickable: true,
							type: pagination_type,
							renderFraction: function (currentClass, totalClass) {
								return '<span class="' + currentClass + '"></span>' +
									' <span class="slash">/</span> ' +
									'<span class="' + totalClass + '"></span>';
							}
						},
						navigation: {
							nextEl: '[data-random="' + randomId + '"] .swiper-button-next',
							prevEl: '[data-random="' + randomId + '"] .swiper-button-prev'
						},
						on: {
							slideChangeTransitionStart: function (swiper) {
								swiper.el.parentNode.classList.toggle('changed', swiper.realIndex > 0);
								swiper.el.parentNode.classList.toggle('last-slide-active', swiper.realIndex + 1 === total_sl);
							}
						}
					});
				}
			}
		});
	}
});
window.dispatchEvent(listStaticSliderEvt);

window.addEventListener("listUspSlider", function (event) {
	list_usp = document.querySelectorAll('.l4us:not(.s4wi)');
	if (list_usp.length) {
		requestAnimationFrame(() => { // 🔥 Wacht tot volgende repaint
			list_usp.forEach(function (el) {
				if (!el.classList.contains('static')) {
					let autoplay_int = false;
					let autowidth_int = 1;
						let space_between = el.classList.contains('no-arrows') ? 16 : 44;
						let isSlider = el.classList.contains('slider');
						let hasAutoplay = el.hasAttribute('data-autoplay');

					if (hasAutoplay) {
						autoplay_int = {
							delay: parseFloat(el.getAttribute('data-autoplay')),
							pauseOnMouseEnter: true,
							disableOnInteraction: false
						};
					}

					randomize(el);
					const randomId = el.getAttribute('data-random');

					if (el.querySelectorAll('li').length === 1) {
						el.classList.remove('slider', 'slider-single'); // 🔥 Beperk classlist manipulatie
					}

					const options = {
						direction: 'horizontal',
						loop: true,
						pagination: false,
						autoplay: autoplay_int,
						slidesPerView: autowidth_int,
						autoHeight: true,
						spaceBetween: space_between,
						navigation: {
							nextEl: `[data-random="${randomId}"] .swiper-button-next`,
							prevEl: `[data-random="${randomId}"] .swiper-button-prev`
						},
						breakpoints: {
							0: { slidesPerView: 1 },
							760: { slidesPerView: autowidth_int },
							1000: { spaceBetween: space_between },
							1100: { spaceBetween: 20 }
						}
					};

					if (!el.classList.contains('mobile-static')) {
						requestAnimationFrame(() => {
							if (isSlider) {
								create_slider(el, options);
							} else if (el.childNodes.length > 1) {
								clone_with_class(el, 'l4us-mobile', 'mobile-hide');
								const nextElement = el.nextElementSibling;
								if (nextElement?.classList.contains('l4us-mobile')) {
									nextElement.classList.remove('slider', 'slider-in-header');
									nextElement.removeAttribute('id');
									create_slider(nextElement, options);
								}
							}
						});
					}
				}
			});
		});
	}
});
window.dispatchEvent(listUspSliderEvt);

popup_a = document.getElementsByClassName('popup-a');
if (popup_a.length) {
	Array.from(popup_a).forEach(function (el) {
		Array.from(el.getElementsByClassName('l4cl')).forEach(function (el) {
			el.classList.add('in-popup');
		});
	});
}

window.addEventListener("listCollection", function(event) {
const list_collection = document.querySelectorAll('.l4cl:not(.l4cl-initialized)');
if (list_collection.length) {
	Array.from(list_collection).forEach(el => {
		el.classList.add('l4cl-initialized');
		if (el.classList.contains('hr')) {
			if (el.clientHeight < el.scrollHeight) {
				el.classList.add('is-scrollable');
			}
		}
		Array.from(el.querySelectorAll('div.box')).forEach(em => {
			const closestLi = em.closest('li');
			if (closestLi) {
				closestLi.classList.add('has-div-box');
			}
		});
		const listItems = Array.from(el.querySelectorAll('li'));
		const itemsWithPictures = new Set(
			Array.from(el.querySelectorAll('li picture ~ picture')).map(em => em.closest('li'))
		);

		requestAnimationFrame(() => {
			listItems.forEach(em => {
				if (itemsWithPictures.has(em)) {
					em.classList.add('has-picture-picture');
				}
			});
		});
	});
}
});
window.dispatchEvent(listCollectionEvt);

window.addEventListener("listCollectionSlider", function(event) {
	window.dispatchEvent(sykSliderEvt);
});

const productGalleryPristine = new WeakMap();

function productGalleryWantsSlider(el) {
	if (el.dataset.mediaLayout === 'slider') return true;
	// A desktop grid is already complete in Liquid/CSS and needs no Swiper DOM;
	// it only becomes a slider once the viewport drops below the grid breakpoint.
	return window.matchMedia('(max-width: 1000px)').matches;
}

function buildProductGallerySwiper(el) {
		el.dataset.gallerySlider = 'true';
		let hasStickyNote = false;
		let stickyNotesArray = [];

		// On smaller screens enhance the same server-rendered gallery in place.
		if (el.classList.contains('static')) {
			el.classList.remove('static');
			el.classList.add('product-gallery-mobile');
		}

		// Verzamel sticky-notes en verwijder ze uit de DOM (batch verwijderen)
		const stickyNotes = el.querySelectorAll('li.sticky');
		if (stickyNotes.length) {
			hasStickyNote = true;
			stickyNotesArray = Array.from(stickyNotes);
			stickyNotesArray.forEach(child => child.remove());
		}

		// Keep the server-rendered media and controls as the source of truth.
		const mainSliderElement = el;
		const mediaItems = Array.from(mainSliderElement.children).filter(child => child.matches('li:not([data-product-gallery-controls])'));
		const totalChildren = mediaItems.length;
		const galleryThumbnailList = mainSliderElement.querySelector('[data-product-gallery-thumbnails]');
		const galleryThumbnails = Array.from(mainSliderElement.querySelectorAll('[data-l4pr-index]'));
		const galleryPrevious = mainSliderElement.querySelector('.swiper-button-prev');
		const galleryNext = mainSliderElement.querySelector('.swiper-button-next');
		let mainSlider;
		let initialSlide = 0;

		// Voorzie in de static poster door alle eerste modellen te vervangen door een plaatje
		const firstModels = mainSliderElement.querySelectorAll('a > .model-3d:first-child model-viewer[poster]');
		firstModels.forEach(em => {
			const staticPosterWrapper = document.createElement('picture');
			const posterSrc = em.getAttribute('poster');
			const staticPoster = document.createElement('img');
			staticPoster.setAttribute('src', posterSrc);
			staticPoster.setAttribute('data-src', posterSrc);
			staticPosterWrapper.appendChild(staticPoster);
			staticPosterWrapper.classList.add('just-poster');
			const altAttribute = em.getAttribute('alt');
			if (altAttribute) {
				staticPoster.setAttribute('alt', altAttribute);
			}
			const closestLink = em.closest('a');
			if (closestLink) {
				// Gebruik insertBefore om als eerste kind te plaatsen
				closestLink.insertBefore(staticPosterWrapper, closestLink.firstChild);
			}
		});

		// Bepaal het initiële slide op basis van data-attribuut
		const featuredMediaPosition = el.getAttribute('data-featured_media_position');
		const isMobileGallery = window.matchMedia('(max-width: 760px)').matches;
		const followVariantImageOnMobile = el.dataset.mobileFollowVariantImage !== 'false';
		if (featuredMediaPosition && (!isMobileGallery || followVariantImageOnMobile)) {
			initialSlide = parseFloat(featuredMediaPosition) - 1;
		}
		initialSlide = Math.max(0, Math.min(initialSlide, totalChildren - 1));

		// Verplaats de elementen met class "m6bx" naar de eerste slide; gebruik een fragment om herhaalde DOM-wijzigingen te vermijden
		const m6bxElements = Array.from(el.getElementsByClassName('m6bx'));
		if (m6bxElements.length) {
			const frag = document.createDocumentFragment();
			m6bxElements.forEach(em => {
				em.classList.add('m6bx-inside');
				frag.appendChild(em);
			});
			// Voeg in één operatie toe aan het eerste kind
			el.firstElementChild.appendChild(frag);
		}

		function updateGalleryControls(swiper, behavior) {
			galleryThumbnails.forEach((thumbnail, index) => {
				const active = index === swiper.realIndex;
				thumbnail.classList.toggle('swiper-pagination-bullet-active', active);
				thumbnail.setAttribute('aria-pressed', active ? 'true' : 'false');
			});

			const current = mainSliderElement.querySelector('.swiper-pagination-current');
			if (current) current.textContent = swiper.realIndex + 1;
			mainSliderElement.classList.toggle('last-slide-active', swiper.realIndex + 1 === totalChildren);

			if (!window.matchMedia('(max-width: 760px)').matches || !galleryThumbnailList) return;
			const activeThumbnail = galleryThumbnails[swiper.realIndex];
			if (!activeThumbnail || galleryThumbnailList.scrollWidth <= galleryThumbnailList.clientWidth) return;

			const targetLeft = activeThumbnail.offsetLeft - ((galleryThumbnailList.clientWidth - activeThumbnail.offsetWidth) / 2);
			galleryThumbnailList.scrollTo({
				left: Math.max(0, targetLeft),
				behavior: behavior || 'smooth'
			});
		}

		mainSlider = create_slider(mainSliderElement, {
			direction: 'horizontal',
			loop: false,
			autoHeight: false,
			preloadImages: false,
			initialSlide: initialSlide,
			navigation: {
				nextEl: galleryNext,
				prevEl: galleryPrevious
			},
			on: {
				afterInit: function (swiper) {
					// Batch verplaatsingen met document fragments om layout trashing te vermijden
					const parentNode = swiper.el.parentNode;
					const labels = Array.from(swiper.el.querySelectorAll('.s1lb, .label'));
					if (labels.length) {
						const frag = document.createDocumentFragment();
						labels.forEach(em => frag.appendChild(em));
						parentNode.appendChild(frag);
					}
					const m6bxInside = Array.from(swiper.el.getElementsByClassName('m6bx-inside'));
					if (m6bxInside.length) {
						const frag2 = document.createDocumentFragment();
						m6bxInside.forEach(em => frag2.appendChild(em));
						swiper.el.appendChild(frag2);
					}
					updateGalleryControls(swiper, 'auto');
				},
				slideChangeTransitionStart: function (swiper) {
					updateGalleryControls(swiper, 'smooth');
					mainSliderElement.classList.toggle('changed', swiper.realIndex > 0);
				}
			}
		});

		// Voeg sticky-notes (indien aanwezig) in één batch toe aan de swiper-outer (of aan de slider zelf)
		if (hasStickyNote) {
			const container = el.querySelector('.swiper-outer') || el;
			stickyNotesArray.forEach(function (note) {
				container.appendChild(note);
			});
		}

		// Thumbnails are server-rendered; JavaScript only connects interaction.
		const dataUpdateProductSliders = el.querySelectorAll('[data-l4pr-index]');
		if (dataUpdateProductSliders.length) {
			dataUpdateProductSliders.forEach(item => {
				const isOption = item.tagName.toLowerCase() === 'option';
				const clickHandler = e => {
					const index = parseInt(item.getAttribute('data-l4pr-index'));
					if (mainSlider && Number.isInteger(index)) mainSlider.slideTo(index);
					if (item.tagName.toLowerCase() === 'a') e.preventDefault();
				};

				if (isOption) {
					const parent = item.parentNode;
					parent.addEventListener('change', () => {
						const dx = parent.options[parent.selectedIndex].getAttribute('data-l4pr-index');
						if (mainSlider && dx !== null) {
							mainSlider.slideTo(dx);
						}
					});
				} else {
					item.addEventListener('click', clickHandler);
				}
			});
		}
}

function teardownProductGallerySwiper(el) {
	delete el.dataset.gallerySlider;
	const swiperInstance = el.querySelector(':scope > .swiper-outer')?.swiper;
	if (swiperInstance) swiperInstance.destroy(true, false);
	const snapshot = productGalleryPristine.get(el);
	if (snapshot) {
		el.innerHTML = snapshot.html;
		el.className = snapshot.className;
	}
}

function syncProductGallery(el) {
	const wantsSlider = productGalleryWantsSlider(el);
	const isSlider = el.dataset.gallerySlider === 'true';
	if (wantsSlider && !isSlider) {
		productGalleryPristine.set(el, { html: el.innerHTML, className: el.className });
		buildProductGallerySwiper(el);
	} else if (!wantsSlider && isSlider) {
		teardownProductGallerySwiper(el);
	}
}

window.addEventListener("listProductSlider", function () {
	document.querySelectorAll('.l4pr').forEach(syncProductGallery);
});
window.addEventListener('windowResize', function () {
	document.querySelectorAll('.l4pr').forEach(syncProductGallery);
});
window.dispatchEvent(listProductSliderEvt);



const alignMiddleElements = document.getElementsByClassName('align-middle');
const alignCenterElements = document.getElementsByClassName('align-center');

function checkAndAddClass(elements, className) {
	if (elements.length) {
		Array.from(elements).forEach(el => {
			const parent = el.parentNode;
			const grandparent = parent.parentNode;

			const isCenterElement = (
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.id === 'content') ||
				(el.previousElementSibling === null && el.nextElementSibling === null && parent.previousElementSibling === null && parent.nextElementSibling === null && grandparent.id === 'content')
			);

			if (isCenterElement) {
				document.getElementById('content').classList.add(className);
			}
		});
	}
}

checkAndAddClass(alignMiddleElements, 'align-center');
checkAndAddClass(alignCenterElements, 'align-center-static');

if (!isHasSelectorSupported()) {
	const list_featured_content_box = document.querySelectorAll('.l4ft .content.box');
	if (list_featured_content_box.length) {
		Array.from(list_featured_content_box).forEach(el => {
			const closestLi = el.closest('li');
			if (closestLi) {
				closestLi.classList.add('has-content-box');
			}
		});
	}
}

if (isMobile) {
	html_tag.classList.add('mobile');
} else {
	html_tag.classList.add('no-mobile');
}

new_js(window.filepaths['custom_async_js']);

window.addEventListener("mediaFlexbile", function(evt) {
const media_flexible = document.getElementsByClassName('media-flexible');
if (media_flexible.length) {
	Array.from(media_flexible).forEach(function (el) {
    if ((!el.parentElement.classList.contains('flexible-stack') && (el.classList.contains('slider-mobile') || el.parentElement.classList.contains('mobile-static'))) && (!el.classList.contains('media-flexible-initialized'))) {
			var cloned_mobile, link, emc, pt = el.parentElement,
				tag = document.createElement('div'),
				fl = pt.querySelectorAll('.media-flexible:not(.mobile-hide-media-flexible) > *:not(.mobile-hide-media-flexible)');
			if (!el.parentElement.getElementsByClassName('media-flexible-mobile').length) {
				tag.classList.add('media-flexible-mobile');
				el.after(tag);
				el.classList.add('mobile-hide');
				const cloned_mobile = pt.querySelector('.media-flexible-mobile');
				Array.from(fl).forEach(function (em) {
					emc = em.cloneNode(true);
					cloned_mobile.appendChild(emc);
				});

				if (cloned_mobile.classList.contains('media-flexible-mobile')) {
					cloned_mobile.classList.remove('media-flexible', 'mobile-hide');
					if (cloned_mobile.hasAttribute('id')) {
						cloned_mobile.removeAttribute('id');
					}

					Array.from(cloned_mobile.children).forEach(function (el) {
						if (el.classList.contains('mobile-hide')) {
							el.remove();
						}
					});
					randomize(cloned_mobile);
					const randomId = cloned_mobile.getAttribute('data-random');
					if (!cloned_mobile.classList.contains('s4wi')) {
						create_slider(cloned_mobile, {
							direction: 'horizontal',
							loop: false,
							autoHeight: true,
							pagination: {
								el: '.swiper-pagination-' + randomId,
								clickable: true,
								type: 'bullets',
								renderBullet: function (index, className) {
									return '<span class="' + className + '">' + (index + 1) + "<span class='prg'></span></span>";
								}
							},
							on: {
								slideChangeTransitionStart: function (swiper) {
									var active_content = swiper.el.querySelectorAll('.swiper-slide[data-swiper-slide-index="' + swiper.realIndex + '"] > *')[0];
									if (typeof active_content !== 'undefined') {
										el.closest('.m6fr').setAttribute('data-active-content', active_content.getAttribute('data-color-palette'));
									}
								}
							}
						});
					}
				}
			}
      el.classList.add('media-flexible-initialized');
		}
	});
}
});
window.dispatchEvent(mediaFlexibleEvt);

/*!*/
window.addEventListener("createCols", function(event) {
	var servicePageElement = document.querySelector('[id$="page-service-info-blocks"]');
	if (servicePageElement != null) {
		if (servicePageElement.parentElement.classList.contains('cols')) {
			var parent = servicePageElement.parentElement;
			var article = servicePageElement.parentElement.querySelector('article.w64.t55');
			if (article) { article.replaceWith(...article.childNodes); }
			parent.replaceWith(...parent.childNodes);
		}

		var anySiblingFound = false;
		var wrapper = document.createElement('div');
		wrapper.classList.add('cols');
		var wrapperInner = document.createElement('article');
		wrapperInner.classList.add('w64','t55');
		wrapper.appendChild(wrapperInner);
		var possibleSiblings = ['shopify-section-page-service-menu', 'shopify-section-faq', 'shopify-section-contact-form', 'shopify-section-google-maps'];

		var findSibling = function() {
			var prevSibling = servicePageElement.previousSibling;
			if (prevSibling) {
				var correctSiblingFound = false;
				for (var i = 0; i < possibleSiblings.length; i++) {
					if (prevSibling.classList.contains(possibleSiblings[i])) {
						correctSiblingFound = true;
						anySiblingFound = true;
						prevSibling.classList.add('w64','t55')
						wrapperInner.appendChild(prevSibling);
					}
				}
				if (correctSiblingFound) {
					findSibling();
				} else {
					for (var i = 1; i < wrapperInner.childNodes.length; i++){
						wrapperInner.insertBefore(wrapperInner.childNodes[i], wrapperInner.firstChild);
					}
					if (anySiblingFound) {
						servicePageElement.parentNode.insertBefore(wrapper, servicePageElement);
						wrapper.appendChild(servicePageElement);
					}
				}
			}
		}
		findSibling();
	}
});
window.dispatchEvent(createColsEvt);

window.addEventListener("showAlert", function(event) {
	var messageText = event.detail.message,
		messageType = event.detail.type,
		messageHeader = event.detail.header ? event.detail.header : false,
		messageOrigin = event.detail.origin ? 'message-' + event.detail.origin : false,
		messageColor = '';
	switch(messageType) {
		case "success":
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_success_text; }
			break;
		case "info":
			messageColor = 'pine';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_info_text; }
			break;
		case "error":
			messageColor = 'rose';
			if (!messageHeader) { messageHeader = window.translations.general_alerts_error_text; }
			break;
		default:
			messageColor = 'lime';
			if (!messageHeader) { messageHeader = ''; }
	}
	var message = '<li class="overlay-'+ messageColor +' '+ messageOrigin +'"><i aria-hidden="true" class="icon-'+ messageType +'"></i><p class="strong">'+ messageHeader +'</p><p>'+ messageText +'</p><a href="./" class="close">Close</a></li>';
	var list_alerts = document.querySelector('.l4al:not(.inline):not(.l4al-trustbadge)');

	if (list_alerts === null) {
		list_alerts = document.createElement("ul");
		list_alerts.classList.add('l4al', 'fixed');
		document.getElementById('root').appendChild(list_alerts);
	}
	if ((messageOrigin && list_alerts.getElementsByClassName(messageOrigin).length == 0) || !messageOrigin) { // Prevent double messages (multiple of the same forms are being triggered when posted in shopfiy)
		list_alerts.innerHTML += message;
	}
	if (typeof alertsEvt != 'undefined') { window.dispatchEvent(alertsEvt); }
}, false);

function scrollToTargetAdjusted(el) {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}
	el.scrollIntoView({
		block: 'center'
	});
}
let loadMoreItemClicked = localStorage.getItem('loadMoreItemClicked');
if (loadMoreItemClicked != null) {
	let el = document.querySelector('#collection > li > figure > a[href="'+ loadMoreItemClicked +'"], .m6cl .results > div a[href="'+ loadMoreItemClicked +'"], .m6cl .results > .l4ne a[href="'+ loadMoreItemClicked +'"]'),
		url = window.location.href;
	if (el && !url.includes(loadMoreItemClicked)) {
		scrollToTargetAdjusted(el);
		localStorage.removeItem('loadMoreItemClicked');
	} else if (!url.includes(loadMoreItemClicked)) {
		localStorage.removeItem('loadMoreItemClicked');
	}
}

window.addEventListener("lazyVideo", function (evt) {
	"use strict";

	var lazyVideos = document.querySelectorAll("video.lazy");

	if ("IntersectionObserver" in window) {
		var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					const video = entry.target;
					const sources = Array.from(video.children);

					sources.forEach(videoSource => {
						if (videoSource.tagName === "SOURCE") {
							videoSource.src = videoSource.dataset.src;
						}
					});

					video.load();

					requestAnimationFrame(() => {
						video.classList.remove("lazy");
					});

					lazyVideoObserver.unobserve(video);
				}
			});
		});

		lazyVideos.forEach(function (lazyVideo) {
			lazyVideoObserver.observe(lazyVideo);
		});
	}
});

document.addEventListener("DOMContentLoaded", function () {
	window.dispatchEvent(lazyVideoEvt);
});


/*!*/
// Animations .t1an
function loadRes(u, c, i) {
	'use strict';
	if (html_tag.classList.contains(i)) {
		c();
		return true;
	}
	var s = document.createElement('script');
	s.src = u;
	s.async = true;
	s.onload = c;
	document.body.appendChild(s);
	if (!html_tag.classList.contains(i)) {
		html_tag.classList.add(i);
	}
	return true;
}

window.sals = function() {
	var data_sal = document.querySelectorAll('[data-sal]');
	if (data_sal.length) {
		loadRes(window.filepaths['plugin_animations_js'], function () {
			"use strict";
			new_css('animation-css', window.filepaths['async_animations_css']);
			sal({
				threshold: 0.2,
				once: true
			});
		}, 'animations-loaded');
	}
}
sals();

function addMobileShopifyChatLabelStyleToRoot(shadowRoot) {
	"use strict";
	var styleId = 'mobile-chat-label-style';
	if (!shadowRoot.getElementById(styleId)) {
		var style = document.createElement('style');
		style.id = styleId;
		style.textContent = '@media only screen and (max-width: 760px) { .activator__label { display: none !important; } }';
		shadowRoot.appendChild(style);
	}
	if (!shadowRoot.mobileChatLabelObserver) {
		shadowRoot.mobileChatLabelObserver = new MutationObserver(function () {
			addMobileShopifyChatLabelStyle();
		});
		shadowRoot.mobileChatLabelObserver.observe(shadowRoot, { childList: true, subtree: true });
	}
}

function addMobileShopifyChatLabelStyle() {
	"use strict";
	var shopifyChat = document.querySelector('shopify-chat');
	if (!shopifyChat || !shopifyChat.shadowRoot) {
		return false;
	}
	addMobileShopifyChatLabelStyleToRoot(shopifyChat.shadowRoot);
	var agentRuntime = shopifyChat.shadowRoot.querySelector('shopify-agent-runtime');
	if (agentRuntime && agentRuntime.shadowRoot) {
		addMobileShopifyChatLabelStyleToRoot(agentRuntime.shadowRoot);
	}
	return true;
}

function initMobileShopifyChatLabel() {
	"use strict";
	if (addMobileShopifyChatLabelStyle()) {
		return;
	}
	var shopifyChatObserver = new MutationObserver(function () {
		if (addMobileShopifyChatLabelStyle()) {
			shopifyChatObserver.disconnect();
		}
	});
	shopifyChatObserver.observe(document.documentElement, { childList: true, subtree: true });
	if (window.customElements && window.customElements.whenDefined) {
		window.customElements.whenDefined('shopify-chat').then(function () {
			if (addMobileShopifyChatLabelStyle()) {
				shopifyChatObserver.disconnect();
			}
		});
	}
	window.setTimeout(function () {
		shopifyChatObserver.disconnect();
	}, 30000);
}

initMobileShopifyChatLabel();
